import React, { useEffect, useRef, useState } from 'react';
import { View, Text, TextInput, Modal, NativeModules, StatusBar, Platform, Keyboard } from 'react-native';
import CustomPressable from '../../components/customPressable/customPressable';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import { linkToRoom, logoutUserFunc } from '../../Redux/Actions/roomLinkingAction';
import { makeLayoutApiCalls } from '../../js/fetchAppConfigs';
import { setGoHome, setIsShownWelcomeScreen, setRedirectToTabId, setShowLoginModal, setTempSelectedHotel } from '../../Redux/Reducers/appConfigReducer';
import { CustomModal } from '../../components/customModal';
import KeyboardAvoidingWrapper from '../../components/keyboardAvoidingWrapper';
import { setProceedLoginToTheApp, setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { generateToken, isIOS } from '../../utils/Helper';
import Loader from '../../components/Loader/loader';
import { CustomTextInput } from '../../components/customTextInput';
import CustomFlatList from '../../components/customFlatList';
import { resetGuestRoomState, setGuestRoomData, setGuestRoomState } from '../../Redux/Reducers/guestRoomReducer';
import { useNavigation } from '@react-navigation/native';
import { CHECK_IN } from '../../navigation/StackNavigator/routes';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import moment from 'moment';
import { checkBookingStatus } from '../../Redux/Actions/checkInAction';
import { formatDate } from '../../js/formatDate';
import SliderPressable from '../../components/customPressable/sliderPressable';
import CustomDropDown from '../../components/customDropdown/customDropdown';
import FlashMessageComp from '../../components/flashMessage/flashMessage';

const { StatusBarManager } = NativeModules;

const GuestRoomStatus = () => {
  const { t } = useTranslation();
  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const { appVersion, appBuildNumber, tempSelectedHotel, shownWelcomeScreen, isLoggedIn, renderFlashMessage } = useSelector(state => state.appConfigSlice);
  const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);
  const { guestDetails, widgetSessionId } = useSelector(state => state.guestRoomSlice);
  const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice)

  // const { allowUserLoginViaFindingReservation } = useSelector(state => state.deviceConfigSlice.webAppWidgetsInfo?.appConfigs);
  const { webAppWidgetsInfo, extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
  const preCheckInTimeLimit = webAppWidgetsInfo?.mobileCheckInConfigs?.preCheckInTimeLimit || undefined

  const { allowUserLoginViaFindingReservation, allowUserSelectLocation } = webAppWidgetsInfo?.appConfigs || {};

  const { hotelListData } = useSelector(state => state.hotelSelectorSlice);
  const hotelListsInfo = hotelListData?.payload?.data;
  
  const dateFormat = extraConfigParam?.DATE_FORMAT;

  const { preCheckInCompleted } = useSelector(state => state.checkInSlice.preCheckInStatus);
  const { activeState, guestList, otpMessage } = useSelector(state => state.guestRoomSlice);
  const [selectedGuest, setSelectedGuest] = useState();

  const [accessCode, setAccessCode] = useState(); // OTP
  const otpInputRefs = useRef([]);


  const [findResSessionToken, setFindResSessionToken] = useState(() => widgetSessionId || generateToken("findRes_"));


  const [statusBarHeight, setStatusBarHeight] = useState(0);

  const [loginFormData, setLoginFormData] = useState({
    lastName: guestDetails?.lastName,
    roomNumber: guestDetails?.roomNumber,
    checkinDate: guestDetails?.checkinDate,
    confirmationNumber: guestDetails?.confirmationNumber,
    candoAccompanyLogin: guestDetails?.candoAccompanyLogin ?? true,
    candoOtpFlow: guestDetails?.candoOtpFlow ?? true,
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [loading, setLoading] = useState(false);

  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);

  const firstInputRef = useRef(null);


  const validateInput = (isForLinkToRoom=false) => {
    const errors = {};

    if(!isForLinkToRoom && allowUserSelectLocation && !tempSelectedHotel?.hotelPropertyKey) {
      errors['selectLocation'] = t('login.field_required');
    }

    // Iterate through required fields and validate
    if (!loginFormData['lastName']?.trim()) {
      errors['lastName'] = t('login.field_required');
    }

    if (!isForLinkToRoom && allowUserLoginViaFindingReservation) {
      if (!loginFormData['checkinDate']?.trim()) {
        errors['checkinDate'] = t('login.field_required');
      }
    } else {
      if (!loginFormData['roomNumber']?.trim()) {
        errors['roomNumber'] = t('login.field_required');
      }
    }

    // add handling as per active state as well.
    if (activeState == "otp") {
      if (!accessCode?.trim()) {
        errors['accessCode'] = t('login.field_required');
      }
    } else if (activeState == "multiple_guest") {
      if (!selectedGuest) {
        errors['selectedGuest'] = t('login.field_required');
      }
    }

    if (activeState == "multipleInHouseConflict" || activeState == "get_login_roomnumber") {
      if (!loginFormData['roomNumber']?.trim()) {
        errors['roomNumber'] = t('login.field_required');
      }
    }

    if (activeState == "multipleDueInConfict") {
      if (!loginFormData['confirmationNumber']?.trim()) {
        errors['confirmationNumber'] = t('login.field_required');
      }
    }

    setErrorMessage(errors);
    return Object.keys(errors).length === 0;
  };

  const handleConnectCallback = (status, errorMessage) => {
    setLoading(false);
  };

  const handleConnect = async () => {
    if (!validateInput(true)) return;

    setLoading(true);
    Keyboard.dismiss();
    try {
      dispatch(linkToRoom({ lastName: loginFormData.lastName, roomNumber: loginFormData.roomNumber, candoAccompanyLogin: loginFormData.candoAccompanyLogin, candoOtpFlow: loginFormData.candoOtpFlow }, handleConnectCallback, accessCode, selectedGuest))
    } catch (error) {
      setLoading(false);
      dispatch(setRenderFlashMessage(true, { type: "danger", message: error || "Something went wrong" }));
    }
  };


  const handleIsBookingAvailable = async (flowIntent) => {
    if (!validateInput()) return;

    setLoading(true);
    Keyboard.dismiss();

    try {
      const { status, response, message } = await dispatch(checkBookingStatus({ ...loginFormData, flowIntent }, findResSessionToken, "FIND_YOUR_RESERVATION"));
      setLoading(false);

      if (status == "SUCCESS") {
        // let guestData = response?.payload ? { ...response.payload, checkinDate: loginFormData.checkinDate } : {};

        handleCloseModal();

        // commenting below code because we can't get route in this modal but it will create issue in case we start pre checkin from pre checkin widget in conflict cases.
        // if(route?.name != CHECK_IN) {
        //   dispatch(setGoHome(true));
        // } else {
        //   // navigation.navigate(CHECK_IN, { findMyRes: true, widgetSessionId: findResSessionToken });
        // }

        if(!shownWelcomeScreen){
          dispatch(setGoHome(true));
          dispatch(setIsShownWelcomeScreen(true));
        } else {
          // alternative approach
          // dispatch(setGoHome(true));

          setTimeout(() => {
            navigation.navigate(CHECK_IN, { findMyRes: true, widgetSessionId: findResSessionToken });
          }, 10);  
        }
        
      } else if (status == "LINKTOROOM" || status == "BOOKING_SUCCESS_ANOTHER_CONNECTOR") {
        dispatch(setIsShownWelcomeScreen(true));
        // dispatch(setGoHome(true));
        handleCloseModal();
      } else if (status == "FAILURE") {
        dispatch(setRenderFlashMessage(true, { type: "danger", message: message || "Booking not found with provided details." }));
      }


    } catch (error) {
      setLoading(false);
      dispatch(setRenderFlashMessage(true, { type: "danger", message: error || "Something went wrong" }));
    }
  }


  const handleNavigateToCheckIn = () => {
    handleCloseModal();
    navigation.navigate(CHECK_IN);
  }


  const handleInHouseAndDueInConflict = (flowIntent) => {

    if(flowIntent == "checkin"){
      dispatch(setGuestRoomData({activeState: 'multipleDueInConfict'}));
      return;
    }


    if(flowIntent == "login"){
      dispatch(setGuestRoomData({activeState: 'multipleInHouseConflict'}));
      return;
    }

    handleIsBookingAvailable(flowIntent);
  }


  const handleLogoutCallback = (status, error) => {
    setLoading(false);
    if (!status) {
      dispatch(setRenderFlashMessage(true, { type: "danger", message: error || "Something went wrong" }));
    } else {
      dispatch(setShowLoginModal(false));
    }
  }

  const handleLogout = () => {
    setLoading(true);
    dispatch(logoutUserFunc(handleLogoutCallback));
  };

  const handleInputChange = (name, value) => {
    setLoginFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrorMessage((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  const handleCloseModal = () => {
    dispatch(setShowLoginModal(false));
  };

  const setModalDefault = () => {
    setSelectedGuest(null);
    setAccessCode(null);
    dispatch(resetGuestRoomState({ donotResetGuestDetails: true }));
  }


  const getStatusBarHeight = () => {
    if (Platform.OS === 'ios') {
      StatusBarManager.getHeight((height) => setStatusBarHeight(height.height || 0));
    } else {
      setStatusBarHeight(StatusBar.currentHeight || 0);
    }
  };


  const handleOtpInputChange = (text, index) => {
    const otpArray = accessCode?.split('') || [];
    otpArray[index] = text;
    setAccessCode(otpArray.join(''));

    // Move focus to the next input
    if (text && index < otpInputRefs.current.length - 1) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  // Handle key press for backspace (move focus to the previous input if needed)
  const handleKeyPress = (e, index) => {
    if (e.nativeEvent.key === 'Backspace' && !accessCode[index] && index > 0) {
      otpInputRefs.current[index - 1].focus();
    }
  };

   const handleTempLocationSelect = (selectedTempLocation) => {
      if (!selectedTempLocation?.value) return;
      
      // Flatten all hotelList arrays and find the hotel by hotelPropertyKey
      const selectedHotel = hotelListsInfo
        ?.flatMap(region => region.hotelList || [])
        .find(hotel => hotel.hotelPropertyKey === selectedTempLocation.value);
    
      dispatch(setTempSelectedHotel(selectedHotel ?? null));
    };




  useEffect(() => {
    setLoginFormData({
      lastName: guestDetails?.lastName,
      roomNumber: guestDetails?.roomNumber,
      checkinDate: guestDetails?.checkinDate,
      confirmationNumber: guestDetails?.confirmationNumber,
      candoAccompanyLogin: guestDetails?.candoAccompanyLogin ?? true,
      candoOtpFlow: guestDetails?.candoOtpFlow ?? true,
    })
  }, [guestDetails])

  useEffect(() => {

    // if (preCheckInCompleted) {
    //   setTimeout(() => {
    //     navigation.navigate(CHECK_IN);
    //   }, 10);
    //   handleCloseModal();
    //   return;
    // }

    getStatusBarHeight();

    // if (!isLoggedIn) {
    //   setTimeout(() => {
    //     firstInputRef.current?.focus();
    //   }, 50);
    // }

    return () => {
      dispatch(resetGuestRoomState());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderLoginModal = () => (
    <CustomModal onRequestClose={handleCloseModal}>
      {renderFlashMessage.isVisible && <FlashMessageComp messageConfig={renderFlashMessage.messageConfig} />}
      <KeyboardAvoidingWrapper style={getStyles(['modalOverlay'])} keyboardVerticalOffset={0}>
        <>

        {activeState == 'otp' ?
          <View style={getStyles([{ marginTop: Platform.OS === 'ios' ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
            <Text style={getStyles(['LoginModalTitle'])}>{t('login.otp_heading')}</Text>

            <View style={getStyles(['LoginModalDisclaimerContainer'])}>
              <Text style={getStyles(['LoginModalDisclaimerText'])}>
                {otpMessage}
              </Text>
            </View>

            <View style={getStyles(['otpPinContainer'])}>
              {Array(4).fill().map((_, index) => (
                <OtpInput
                  key={index}
                  ref={(el) => (otpInputRefs.current[index] = el)}
                  index={index}
                  value={accessCode ? accessCode[index] : ''}
                  onChangeText={handleOtpInputChange}
                  onKeyPress={(e) => handleKeyPress(e, index)}
                  getStyles={getStyles}
                />
              ))}
              {errorMessage['accessCode'] && (
                <Text style={getStyles(['errorText'])}>{t('login.error_OTP')}</Text>
              )}
            </View>

            <View style={getStyles(['loginModalButtonContainer'])} >
              <CustomPressable style={getStyles(['primaryBtn'])} disabled={loading} onPress={handleConnect}>
                {loading ? (
                  <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                ) : (
                  <Text style={getStyles(['primaryBtnTxt'])}>{t('login.primary_button')}</Text>
                )}
              </CustomPressable>

              <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
                <Text style={getStyles(['secondaryBtnTxt'])}>{t('login.secondary_button')}</Text>
              </CustomPressable>
            </View>

            <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
          </View>

          : activeState == 'multiple_guest' ?
            <View style={getStyles([{ marginTop: Platform.OS === 'ios' ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
              <Text style={getStyles(['LoginModalTitle'])}>{t('guestList.heading')}</Text>

              {guestList.length && <CustomFlatList
                data={guestList}
                renderItem={({ item, index }) => (
                  <CustomPressable onPress={() => setSelectedGuest(item.id)}>
                    <View style={getStyles(['radioButtonContainer', 'guestListItemContainer'])}>
                      <View style={getStyles(['radioButton'])}>
                        {selectedGuest === item.id && (
                          <View style={getStyles(['radioButtonInner'])} />
                        )}
                      </View>
                      <Text style={getStyles(['openSlotListItems', 'guestListItemTitle'])}>{item.firstName + " " + item.lastName}</Text>
                    </View>
                  </CustomPressable>
                )}
                keyExtractor={(item, index) => index.toString()}
                ListFooterComponent={errorMessage['selectedGuest'] ? (
                  <Text style={getStyles(['errorText'])}>{t('login.error_selectedGuest')}</Text>
                ) : null}
                listKey={item => item.id}
              />}

              <View style={getStyles(['loginModalButtonContainer'])} >
                <CustomPressable style={getStyles(['primaryBtn'])} disabled={!selectedGuest || loading} onPress={handleConnect}>
                  {loading ? (
                    <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                  ) : (
                    <Text style={getStyles(['primaryBtnTxt'])}>{t('guestList.primary_button')}</Text>
                  )}
                </CustomPressable>

                <CustomPressable
                  style={getStyles(['secondaryBtn'])}
                  disabled={loading}
                  onPress={handleCloseModal}
                >
                  <Text style={getStyles(['secondaryBtnTxt'])}>{t('guestList.secondary_button')}</Text>
                </CustomPressable>
              </View>

              <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
            </View>


            : activeState == "multipleInHouseConflict" || activeState == "get_login_roomnumber" ?
              <View style={getStyles([{ marginTop: isIOS() ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
                <Text style={getStyles(['LoginModalTitle'])}>{t('login.multipleInHouseConflict_heading')}</Text>

                <View style={getStyles(['LoginModalDisclaimerContainer'])}>
                  <Text style={getStyles(['LoginModalDisclaimerText'])}>
                    {t('login.multipleInHouseConflict_subheading')}
                  </Text>
                </View>

                <View style={getStyles(['textContainer'])} >
                  <Text style={getStyles(['label'])}>{t('login.roomNumber')}</Text>
                  <CustomTextInput
                    value={loginFormData['roomNumber']}
                    onChangeText={(text) => handleInputChange('roomNumber', text)}
                    placeholder={t('login.enter_roomNumber')}
                  />
                  {errorMessage['roomNumber'] && (
                    <Text style={getStyles(['errorText'])}>{t('login.error_roomNumber')}</Text>
                  )}
                </View>

                <View style={getStyles(['loginModalButtonContainer'])} >
                  <CustomPressable style={getStyles(['primaryBtn'])} disabled={loading} onPress={activeState == "get_login_roomnumber" ? handleConnect : () => handleIsBookingAvailable('login')}>
                    {loading ? (
                      <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                    ) : (
                      <Text style={getStyles(['primaryBtnTxt'])}>{t('login.primary_button')}</Text>
                    )}
                  </CustomPressable>

                  <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('login.secondary_button')}</Text>
                  </CustomPressable>
                </View>

                <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
              </View>



              : activeState == "multipleDueInConfict" ?
                <View style={getStyles([{ marginTop: isIOS() ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
                  <Text style={getStyles(['LoginModalTitle'])}>{t('login.multipleDueInConfict_heading')}</Text>

                  <View style={getStyles(['LoginModalDisclaimerContainer'])}>
                    <Text style={getStyles(['LoginModalDisclaimerText'])}>
                      {t('login.multipleDueInConfict_subheading')}
                    </Text>
                  </View>

                  <View style={getStyles(['textContainer'])}>
                    <Text style={getStyles(['label'])}>{t('login.confirmationNumber')}</Text>
                    <CustomTextInput
                      value={loginFormData['confirmationNumber']}
                      onChangeText={(text) => handleInputChange('confirmationNumber', text)}
                      placeholder={t('login.enter_confirmationNumber')}
                    />
                    {errorMessage['confirmationNumber'] && (
                      <Text style={getStyles(['errorText'])}>{t('login.error_confirmationNumber')}</Text>
                    )}
                  </View>

                  <View style={getStyles(['loginModalButtonContainer'])} >
                    <CustomPressable style={getStyles(['primaryBtn'])} disabled={loading} onPress={() => handleIsBookingAvailable('checkin')}>
                      {loading ? (
                        <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                      ) : (
                        <Text style={getStyles(['primaryBtnTxt'])}>{t('login.primary_button')}</Text>
                      )}
                    </CustomPressable>

                    <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
                      <Text style={getStyles(['secondaryBtnTxt'])}>{t('login.secondary_button')}</Text>
                    </CustomPressable>
                  </View>

                  <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
                </View>



                : activeState == "inHouseAndDueInConflict" ?
                  <View style={getStyles([{ marginTop: isIOS() ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
                    <Text style={getStyles(['LoginModalTitle'])}>{t('login.inHouseAndDueInConflict_heading')}</Text>

                    <View style={getStyles(['LoginModalDisclaimerContainer'])}>
                      <Text style={getStyles(['LoginModalDisclaimerText'])}>
                        {t('login.inHouseAndDueInConflict_subheading')}
                      </Text>
                    </View>

                    <View style={getStyles(['loginModalButtonContainer'])} >
                      <CustomPressable disabled={loading} style={getStyles(['primaryBtn'])} onPress={() => handleInHouseAndDueInConflict('checkin')}>
                        <Text style={getStyles(['primaryBtnTxt'])}>{t('login.inHouseAndDueInConflict_primary_button')}</Text>
                      </CustomPressable>

                      <CustomPressable disabled={loading} style={getStyles(['primaryBtn'])} onPress={() => handleInHouseAndDueInConflict('login')}>
                        <Text style={getStyles(['primaryBtnTxt'])}>{t('login.inHouseAndDueInConflict_secondary_button')}</Text>
                      </CustomPressable>
                    </View>

                    <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
                      <Text style={getStyles(['secondaryBtnTxt'])}>{t('login.secondary_button')}</Text>
                    </CustomPressable>

                    <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
                  </View>




                  : allowUserLoginViaFindingReservation ?

                    <View style={getStyles([{ marginTop: isIOS() ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
                      <Text style={getStyles(['LoginModalTitle'])}>{t('login.heading2')}</Text>

                      <View style={getStyles(['LoginModalDisclaimerContainer'])}>
                        <Text style={getStyles(['LoginModalDisclaimerText'])}>
                          {t('login.disclaimer2')}
                        </Text>
                      </View>

                      {allowUserSelectLocation &&
                        <View style={getStyles(['textContainer'])}>
                          <CustomDropDown
                            label={t('login.select_hotel')}
                            placeholder={t('login.select_hotel_placeholder')}
                            options={hotelListsInfo?.flatMap(item => [
                              { type: 'header', label: item.region, value: null },  // heading item
                              ...item.hotelList?.map(hotel => ({
                                type: 'item',
                                label: hotel.hotelName,
                                value: hotel.hotelPropertyKey,
                              })) || [],
                            ])}
                            selectedOption={tempSelectedHotel?.hotelPropertyKey}
                            onSelectOption={handleTempLocationSelect}
                          />
                          {errorMessage['selectLocation'] && (
                            <Text style={getStyles(['errorText'])}>{t('login.error_selectLocation')}</Text>
                          )}
                        </View>
                      }

                      <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('login.lastName')}</Text>
                        <CustomTextInput
                          ref={firstInputRef}
                          autoComplete="family-name"
                          value={loginFormData['lastName']}
                          onChangeText={(text) => handleInputChange('lastName', text)}
                          placeholder={t('login.enter_lastName')}
                        />
                        {errorMessage['lastName'] && (
                          <Text style={getStyles(['errorText'])}>{t('login.error_lastName')}</Text>
                        )}
                      </View>

                      <View style={getStyles(['textContainer'])} >
                        <Text style={getStyles(['label'])}>{t('login.checkinDate')}</Text>

                        <CustomPressable onPress={() => { Keyboard.dismiss(), setIsDatePickerVisible(true)}}>
                          <CustomTextInput
                            value={loginFormData.checkinDate ? formatDate(loginFormData.checkinDate, dateFormat) : ""}
                            placeholder={t('login.enter_checkinDate')}
                            editable={false}
                            pointerEvents="none"
                          />
                        </CustomPressable>
                        {errorMessage['checkinDate'] && (
                          <Text style={getStyles(['errorText'])}>{t('login.error_checkinDate')}</Text>
                        )}
                      </View>

                      <View style={getStyles(['loginModalButtonContainer'])} >
                        <CustomPressable style={getStyles(['primaryBtn'])} disabled={loading} onPress={() => handleIsBookingAvailable()}>
                          {loading ? (
                            <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                          ) : (
                            <Text style={getStyles(['primaryBtnTxt'])}>{t('login.primary_button')}</Text>
                          )}
                        </CustomPressable>

                        <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
                          <Text style={getStyles(['secondaryBtnTxt'])}>{t('login.secondary_button')}</Text>
                        </CustomPressable>
                      </View>

                      <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
                      
                      <Text style={getStyles(['loginModalBottomTxt'])}>
                        {t('login.login_bottom_msg')}
                      </Text>
                    </View>

                    :
                    <View style={getStyles([{ marginTop: isIOS() ? statusBarHeight : statusBarHeight }, 'loginModalContainer'])}>
                      <Text style={getStyles(['LoginModalTitle'])}>{t('login.heading')}</Text>

                      <View style={getStyles(['LoginModalDisclaimerContainer'])}>
                        <Text style={getStyles(['LoginModalDisclaimerText'])}>
                          {t('login.disclaimer')}
                        </Text>
                      </View>

                      <View style={getStyles(['textContainer'])} >
                        <Text style={getStyles(['label'])}>{t('login.lastName')}</Text>
                        <CustomTextInput
                          ref={firstInputRef}
                          autoComplete="family-name"
                          value={loginFormData['lastName']}
                          onChangeText={(text) => handleInputChange('lastName', text)}
                          placeholder={t('login.enter_lastName')}
                        />
                        {errorMessage['lastName'] && (
                          <Text style={getStyles(['errorText'])}>{t('login.error_lastName')}</Text>
                        )}
                      </View>

                      <View style={getStyles(['textContainer'])} >
                        <Text style={getStyles(['label'])}>{t('login.roomNumber')}</Text>
                        <CustomTextInput
                          value={loginFormData['roomNumber']}
                          onChangeText={(text) => handleInputChange('roomNumber', text)}
                          placeholder={t('login.enter_roomNumber')}
                        />
                        {errorMessage['roomNumber'] && (
                          <Text style={getStyles(['errorText'])}>{t('login.error_roomNumber')}</Text>
                        )}
                      </View>

                      <View style={getStyles(['loginModalButtonContainer'])} >
                        <CustomPressable style={getStyles(['primaryBtn'])} disabled={loading} onPress={handleConnect}>
                          {loading ? (
                            <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                          ) : (
                            <Text style={getStyles(['primaryBtnTxt'])}>{t('login.primary_button')}</Text>
                          )}
                        </CustomPressable>

                        <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
                          <Text style={getStyles(['secondaryBtnTxt'])}>{t('login.secondary_button')}</Text>
                        </CustomPressable>
                      </View>

                      <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
                      
                      <Text style={getStyles(['loginModalBottomTxt'])}>
                        {t('login.login_bottom_msg')}
                      </Text>
                    </View>

        }


        {isDatePickerVisible &&
          <DatePickerModal
            selectedDate={loginFormData.checkinDate}
            onDateChange={(selectedDate) => { handleInputChange('checkinDate', moment(selectedDate).format('YYYY-MM-DD')); setIsDatePickerVisible(false) }}
            onClose={() => setIsDatePickerVisible(false)}
            maxDate={parseInt(preCheckInTimeLimit) > -1 ? new Date(new Date().getTime(serverTimeDataObj?.date?.split("T")[0] + "T00:00:00") + (Math.floor(parseInt(preCheckInTimeLimit) / 24)) * 24 * 60 * 60 * 1000) : null}
            
          />
        }
        </>
      </KeyboardAvoidingWrapper>
    </CustomModal>
  );

  const renderBookingFoundModal = () => (
    <CustomModal onRequestClose={handleCloseModal}>
      <View style={getStyles(['bookingFoundModalContainer'])}>
        <Text style={getStyles(['bookingFoundModalTitle'])}>{t('bookingfound_modal.heading')}</Text>
        <Text style={getStyles(['bookingFoundModalSubTitle'])}>{t('bookingfound_modal.sub_heading')}</Text>

        <View style={getStyles(['bookingFoundModalButtonContainer'])} >
          <SliderPressable text={preCheckInCompleted ? t('bookingfound_modal.checkin_button') : t('bookingfound_modal.pre_checkin_button')} handleOnSuccess={handleNavigateToCheckIn} />

          {/* <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
            <Text style={getStyles(['secondaryBtnTxt'])}>{t('bookingfound_modal.secondary_button')}</Text>
          </CustomPressable> */}

          {<>
              <Text style={getStyles(['guestDetailsButtonContainerText'])}>{t('guest_details.have_room')}</Text>

              <CustomPressable onPress={() =>  dispatch(setGuestRoomData({guestDetails: bookingData, activeState: 'get_login_roomnumber'}))} style={getStyles(['secondaryBtn'])}>
                <Text style={getStyles(['secondaryBtnTxt'])}>{t('guest_details.link_to_room')}</Text>
              </CustomPressable>
          </>}
        </View>

        <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
      </View>
    </CustomModal>
  );

  const renderLogoutModal = () => (
    <CustomModal onRequestClose={handleCloseModal}>
      <View style={getStyles(['logoutModalContainer'])}>
        <Text style={getStyles(['logoutModalTitle'])}>{t('logout.heading')}</Text>

        <View style={getStyles(['logoutModalButtonContainer'])} >
          <CustomPressable disabled={loading} style={getStyles(['primaryBtn'])} onPress={handleLogout}>
            <Text style={getStyles(['primaryBtnTxt'])}>{t('logout.primary_button')}</Text>
          </CustomPressable>

          <CustomPressable disabled={loading} style={getStyles(['secondaryBtn'])} onPress={handleCloseModal}>
            <Text style={getStyles(['secondaryBtnTxt'])}>{t('logout.secondary_button')}</Text>
          </CustomPressable>
        </View>

        <Text style={getStyles(['LoginModalVersionText'])}>{`V${appVersion}(${appBuildNumber})`}</Text>
      </View>
    </CustomModal>
  );


  return (isLoggedIn || activeState == "show_logout") ? renderLogoutModal() : activeState == "get_login_roomnumber" ? renderLoginModal() : isBookingFound ? renderBookingFoundModal() : renderLoginModal()
};


const OtpInput = React.forwardRef(({ index, value, onChangeText, onKeyPress, getStyles }, ref) => {
  return (
    <TextInput
      ref={ref}
      style={getStyles(['doorKeyOtpPinInput'])}
      maxLength={1}
      keyboardType="numeric"
      value={value}
      onChangeText={(text) => onChangeText(text, index)}
      onKeyPress={onKeyPress}
    />
  );
});

export default GuestRoomStatus;